// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMContextService } from '@services/lm-context.service';
import { LMReportsCatalogState } from '@states/models/lm-reports-catalog-state.model';
import { LMStatePersistenceService } from '@services/lm-state-persistence.service';

class LMReportsCatalogStateKeyParams {
  lidKey?: string;
  actorId?: string;
  dataArea?: string;

  getKey(): string {
    let key = '';
    // context service returns empty string for lidkey, if not in mingle.
    if (this.lidKey) {
      key = this.lidKey + '_';
    }
    return key + this.actorId + '_' + this.dataArea + '_banner';
  }
}

@Injectable()
export class LMReportsCatalogStateService {
  private stateKey: string;

  constructor(
    private lmContextService: LMContextService,
    private lmStatePersistenceService: LMStatePersistenceService
  ) {}

  private get key(): string {
    if (!this.stateKey) {
      const stateKeyParams = new LMReportsCatalogStateKeyParams();
      stateKeyParams.lidKey = this.lmContextService.getLidKey();
      stateKeyParams.actorId = this.lmContextService.getActorId();
      stateKeyParams.dataArea = this.lmContextService.getUrlPdlOrDa();
      this.stateKey = stateKeyParams.getKey();
    }
    return this.stateKey;
  }

  public getCatalogReportState(): LMReportsCatalogState {
    return this.lmStatePersistenceService.getState(this.key);
  }

  public saveCatalogReportState(catalogReportStateItem: LMReportsCatalogState): void {
    this.lmStatePersistenceService.persistState(this.key, catalogReportStateItem);
  }

  public deleteCatalogReportState(): void {
    this.lmStatePersistenceService.removeState(this.key);
  }
}
